import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BlogService } from '../../../../services';
import { PublicBlogService } from '../../../../services/public-blog.service';
import { Pagination, Blog } from '../../../../models';
import {  Subscription } from 'rxjs';

@Component({
  selector: 'app-blog-details',
  templateUrl: './blog-details.component.html',
  styleUrls: ['./blog-details.component.css'],
})
export class BlogDetailsComponent implements OnInit {
  blogData: Array<Blog> = [];
  searchTerm: string = '';
  pageNumber = 1;
  pageSize = 3;
  sortBy = '';
  sortOrder = '';
  isPaginated = true;
  totalBlog: number;
  private subscriptions: Array<Subscription> = [];

  onlyActive = false;
  constructor(
    private route: ActivatedRoute,
    private blogService: BlogService,
    private publicBlogService: PublicBlogService
  ) {}

  blog: any;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      const blogsData = this.blogService.getBlog(params['newsId']).subscribe((res) => {
        this.blog = res;
      });
      this.subscriptions.push(blogsData)
    });
    this.getAllBlog();
  }
  getAllBlog() {
    let model: Pagination = {
      searchTerm: this.searchTerm,
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortBy: this.sortBy,
      sortOrder: this.sortOrder,
      isPaginated: this.isPaginated,
      onlyActive: this.onlyActive,
    };

    const blogsData = this.publicBlogService.getBlogs(model).subscribe((response) => {
      this.blogData = response.data;
      this.totalBlog = response.totalCount;
    });
    this.subscriptions.push(blogsData)
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
